"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("draft-plugins/lib/constants");

var _link = _interopRequireDefault(require("draft-plugins/plugins/link"));

var _link2 = require("rich-text-lib/constants/link");

var _AdvancedLinkDecorator = _interopRequireDefault(require("./decorators/AdvancedLinkDecorator"));

var _AdvancedLinkPopoverDecorator = _interopRequireDefault(require("./decorators/AdvancedLinkPopoverDecorator"));

var createAdvancedLinkEntityOptions = function createAdvancedLinkEntityOptions(url, isTargetBlank, isNoFollow, linkDisplayName) {
  var linkType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _link2.LinkTypes.URL;
  var fileMeta = arguments.length > 5 ? arguments[5] : undefined;
  return [_constants.LINK_ENTITY_TYPE, 'MUTABLE', {
    url: url,
    isTargetBlank: isTargetBlank,
    isNoFollow: isNoFollow,
    linkDisplayName: linkDisplayName,
    linkType: linkType,
    fileMeta: fileMeta
  }];
};

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _link.default)(Object.assign({
    Decorator: _AdvancedLinkDecorator.default,
    PopoverDecorator: _AdvancedLinkPopoverDecorator.default,
    entityOptionCreator: createAdvancedLinkEntityOptions
  }, options));
};

exports.default = _default;
module.exports = exports.default;